import { render, staticRenderFns } from "./chiller.vue?vue&type=template&id=f4612720"
import script from "./chiller.vue?vue&type=script&lang=js"
export * from "./chiller.vue?vue&type=script&lang=js"
import style0 from "./chiller.vue?vue&type=style&index=0&id=f4612720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports